import { render } from "./ObjectViewerView.vue?vue&type=template&id=48e59736"
import script from "./ObjectViewerView.vue?vue&type=script&lang=js"
export * from "./ObjectViewerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__